<template lang="pug">
.container-pallete(id="LayersPalette-container")
  .pliselected SELECTED PLAYITEMS {{ $store.state.Medium.playitems_selected_right.length }}
  .pallete-header(@click='expanded = !expanded')
    font-awesome-icon(:icon="expanded ? 'caret-down' : 'caret-right'")
    span &nbsp; {{ $t('Layers')}}
  .layer(
    v-if='expanded',
    v-for='layer of layers',
    :class='{ selected: selectedLayer && selectedLayer.id === layer.id, margintop:  checkMarginTopOnDrag(layer), marginbottom:  checkMarginBottomOnDrag(layer) }',
    draggable,
    @dragstart='dragstart(layer, $event)',
    @dragend='dragend(layer, $event)',
    @dragover='dragover(layer, $event)',
    :id="'LayersPalette-layer' + layer.id"
  )
    .thumbnail(
      :style="{'background-image': 'url(' + getThumbnailPath(layer.File) + ')'}",
      @click='selectLayer(layer, $event)'
    )
    .rows-data(@click.stop='selectLayer(layer, $event)', @dblclick.stop='$emit("editLayer", layer)')
      .row.first
        .name
          MediumIcon(:medium='layer.Medium')
          span &nbsp; {{ layer.Medium.name }}
      .row.second
        .buttons
          .button(@click='toggleHidden(layer)')
            font-awesome-icon(:icon='!hiddenLayers.find(l => l.id === layer.id) ? "eye" : "eye-slash"')
          .button(@click='toggleLocked(layer)')
            font-awesome-icon(:icon='!lockedLayers.find(l => l.id === layer.id) ? "unlock-alt" : "lock"')
  .selectedLayer(id="LayersPalette-selectedLayer" v-if='selectedLayer')
    p.medium-name(v-if='selectedLayer')
      MediumIcon(:medium='selectedLayer.Medium')
      span &nbsp; {{ selectedLayer.Medium.name }}
    .form(v-if='selectedLayer')
      .item.first {{ $t('Dimensions:') }}
      .item W
        input.input-value(id="LayersPalette-dimWidthInput" type="number", min="-9999", max="9999", @blur='updateLayer()', v-model='selectedLayer.width')
        span px
      .item H
        input.input-value(id="LayersPalette-dimHeightInput" type="number", min="-9999", max="9999", @blur='updateLayer()', v-model='selectedLayer.height')
        span px
    .form(v-if='selectedLayer')
      .item.first {{ $t('Apply from:') }}
      .item
        .button(id="LayersPalette-applyFromContentButton" @click='resetDimensions("medium")') {{ $t('Content') }}
      .item
        .button(id="LayersPalette-applyFromLayoutButton" @click='resetDimensions("layout")') {{ $t('Layout') }}
    hr.header
    .form(v-if='selectedLayer')
      .item.first {{ $t('Position on layout:') }}
      .item X
        input.input-value(id="LayersPalette-posAnchorXInput" type="number", min="-9999", max="9999", @blur='updateLayer()', v-model='selectedLayer.anchorX')
        span px
      .item Y
        input.input-value(id="LayersPalette-posAnchorYInput" type="number", min="-9999", max="9999", @blur='updateLayer()', v-model='selectedLayer.anchorY')
        span px
    .form-anchor-buttons
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonTopLeft" @click='setPositionOnViewport("top-left")')
        .anchor-button.top-left
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonTopMiddle" @click='setPositionOnViewport("top-middle")')
        .anchor-button.top-middle
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonTopRight" @click='setPositionOnViewport("top-right")')
        .anchor-button.top-right
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonMiddleLeft" @click='setPositionOnViewport("middle-left")')
        .anchor-button.middle-left
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonMiddleMiddle" @click='setPositionOnViewport("middle-middle")')
        .anchor-button.middle-middle
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonMiddleRight" @click='setPositionOnViewport("middle-right")')
        .anchor-button.middle-right
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonBottomLeft" @click='setPositionOnViewport("bottom-left")')
        .anchor-button.bottom-left
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonBottomMiddle" @click='setPositionOnViewport("bottom-middle")')
        .anchor-button.bottom-middle
      .anchor-button-viewport(id="LayersPalette-anchorPositionButtonBottomRight" @click='setPositionOnViewport("bottom-right")')
        .anchor-button.bottom-right
    .clear
    br
    hr.header
    .item {{ $t('Content:') }}
    .form(v-if='selectedLayer')
      .item.first {{ $t('Fit:') }}
      .item
        .button(id="LayersPalette-contentFitContainButton" @click='setObjectFit("fill")', :class='{ selected: selectedLayer.objectFit === "fill"}') {{ $t('Fill') }}
      .item
        .button(id="LayersPalette-contentFitContainButton" @click='setObjectFit("contain")', :class='{ selected: selectedLayer.objectFit === "contain"}') {{ $t('Contain') }}
      .item
        .button(id="LayersPalette-contentFitCoverButton" @click='setObjectFit("cover")', :class='{ selected: selectedLayer.objectFit === "cover"}') {{ $t('Cover') }}
      .item
        .button(id="LayersPalette-contentFitNoneButton" @click='setObjectFit("none")', :class='{ selected: selectedLayer.objectFit === "none"}') {{ $t('1:1') }}
    p.form {{$t('Position:')}}
    .form-anchor-buttons
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonLeftTop" @click='setObjectPosition("left top")', :class='{ selected: selectedLayer.objectPosition === "left top"}')
        .anchor-button.top-left
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonCenterTop" @click='setObjectPosition("center top")', :class='{ selected: selectedLayer.objectPosition === "center top"}')
        .anchor-button.top-middle
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonRightTop" @click='setObjectPosition("right top")', :class='{ selected: selectedLayer.objectPosition === "right top"}')
        .anchor-button.top-right
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonLeftCenter" @click='setObjectPosition("left center")', :class='{ selected: selectedLayer.objectPosition === "left center"}')
        .anchor-button.middle-left
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonCenterCenter" @click='setObjectPosition("center center")', :class='{ selected: selectedLayer.objectPosition === "center center"}')
        .anchor-button.middle-middle
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonRightCenter" @click='setObjectPosition("right center")', :class='{ selected: selectedLayer.objectPosition === "right center"}')
        .anchor-button.middle-right
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonLeftBottom" @click='setObjectPosition("left bottom")', :class='{ selected: selectedLayer.objectPosition === "left bottom"}')
        .anchor-button.bottom-left
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonCenterBottom" @click='setObjectPosition("center bottom")', :class='{ selected: selectedLayer.objectPosition === "center bottom"}')
        .anchor-button.bottom-middle
      .anchor-button-viewport(id="LayersPalette-anchorContentButtonRightBottom" @click='setObjectPosition("right bottom")', :class='{ selected: selectedLayer.objectPosition === "right bottom"}')
        .anchor-button.bottom-right
    .clear
</template>

<script>
import Vue from 'vue'
import mediaUtils from '../../Common/mediaUtils.mixin'
import MediumIcon from '../../Common/MediumIcon'
export default {
  props: ['layers', 'selectedLayer', 'hiddenLayers', 'lockedLayers', 'playListWithContentSimple'],
  mixins: [mediaUtils],
  components: {
    MediumIcon
  },
  updated () {
    // this.selectedLayer = this.selectedLayer
    if (!this.selectedLayer) return
    if (this.selectedLayer.width === 0) this.selectedLayer.width = this.playListWithContentSimple.playListLayoutWidth
    if (this.selectedLayer.height === 0) this.selectedLayer.height = this.playListWithContentSimple.playListLayoutHeight
  },
  watch: {
    selectedLayer: function (newVal, oldVal) {
      if (!newVal) return
      // this.selectedLayer = this.selectedLayer
      if (this.selectedLayer.width === 0) this.selectedLayer.width = this.playListWithContentSimple.playListLayoutWidth
      if (this.selectedLayer.height === 0) this.selectedLayer.height = this.playListWithContentSimple.playListLayoutHeight
    }
  },
  data () {
    return {
      errors: [],
      expanded: true,
      draggedLayer: undefined,
      draggedOverLayer: undefined
    }
  },
  methods: {
    // drag
    dragstart (layer, $event) {
      this.$emit('selectLayer', { layer, $event })
      this.draggedLayer = layer
    },
    dragover (layer, $event) {
      if (!this.draggedOverLayer) {
        this.draggedOverLayer = layer
        return
      }
      if (this.draggedOverLayer.id !== layer.id) {
        this.draggedOverLayer = layer
      }
    },
    async dragend (layer, $event) {
      if (this.draggedOverLayer.order === this.draggedLayer.order) return
      const direction = this.draggedOverLayer.order < this.draggedLayer.order ? 'left' : 'right'
      await this.$store.dispatch('Medium/movePlaylistItemOrderRewrite',
        {
          direction: direction,
          playListItem: this.draggedLayer,
          desiredOrder: this.draggedOverLayer.order
        }
      )
      this.draggedOverLayer = undefined
      this.draggedLayer = undefined
      this.$emit('loadData')
    },
    checkMarginTopOnDrag (layer) {
      return this.draggedLayer &&
      this.draggedOverLayer &&
      this.draggedOverLayer.id === layer.id &&
      this.draggedLayer.order < this.draggedOverLayer.order
    },
    checkMarginBottomOnDrag (layer) {
      return this.draggedLayer &&
      this.draggedOverLayer &&
      this.draggedOverLayer.id === layer.id &&
      this.draggedLayer.order > this.draggedOverLayer.order
    },
    selectLayer (layer, $event) {
      this.$emit('selectLayer', { layer, $event })
    },
    toggleHidden (layer) {
      this.$emit('toggleLayerHidden', layer)
    },
    toggleLocked (layer) {
      this.$emit('toggleLayerLocked', layer)
    },
    async resetDimensions (destination) {
      if (destination === 'layout') {
        const playlist = this.$store.state.Medium.media_list.find(m => m.id === this.selectedLayer.PlayList)
        this.selectedLayer.width = playlist.playListLayoutWidth
        this.selectedLayer.height = playlist.playListLayoutHeight
      } else {
        const file = this.$store.state.File.file_list.find(f => f.id === this.selectedLayer.Medium.File)
        this.selectedLayer.width = file.originalWidthPixels
        this.selectedLayer.height = file.originalHeightPixels
      }
      await this.updateLayer()
    },
    async setPositionOnViewport (desiredPosition) {
      const playlist = this.$store.state.Medium.media_list.find(m => m.id === this.selectedLayer.PlayList)
      const freeSpaceHorizontal = playlist.playListLayoutWidth - this.selectedLayer.width
      const freeSpaceVertical = playlist.playListLayoutHeight - this.selectedLayer.height
      const desiredCoordinates = desiredPosition.split('-')
      if (desiredCoordinates[0] === 'middle') {
        this.selectedLayer.anchorY = Math.round(freeSpaceVertical / 2)
      } else if (desiredCoordinates[0] === 'bottom') {
        this.selectedLayer.anchorY = freeSpaceVertical
      } else if (desiredCoordinates[0] === 'top') {
        this.selectedLayer.anchorY = 0
      }
      if (desiredCoordinates[1] === 'middle') {
        this.selectedLayer.anchorX = Math.round(freeSpaceHorizontal / 2)
      } else if (desiredCoordinates[1] === 'right') {
        this.selectedLayer.anchorX = freeSpaceHorizontal
      } else if (desiredCoordinates[1] === 'left') {
        this.selectedLayer.anchorX = 0
      }
      await this.updateLayer()
    },
    async setObjectPosition (position) {
      this.selectedLayer.objectPosition = position
      await this.updateLayer()
    },
    async setObjectFit (fit) {
      this.selectedLayer.objectFit = fit
      await this.updateLayer()
    },
    async updateLayer () {
      const paramsIntegers = ['anchorX', 'anchorY', 'width', 'height']
      for (const paramInteger of paramsIntegers) {
        if (isNaN(parseInt(this.selectedLayer[paramInteger]))) {
          return false
        }
      }
      await Vue.axios
        .patch(
          `PlayListItem/${this.selectedLayer.id}`,
          {
            anchorX: this.selectedLayer.anchorX,
            anchorY: this.selectedLayer.anchorY,
            width: this.selectedLayer.width,
            height: this.selectedLayer.height,
            objectFit: this.selectedLayer.objectFit,
            objectPosition: this.selectedLayer.objectPosition,
            objectRotation: this.selectedLayer.objectRotation,
            order: this.selectedLayer.order
          }
        )
      this.$emit('redrawBoundingBox')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../theme-m4b/src/common/var.scss";
.selectedLayer {
  margin-left: 5px;
  .medium-name {
    color: $--color-warning;
  }
  .form {
    display: flex;
    align-items: center;
    margin: 5px 0px;
    color: $--color-text-regular;
    .item {
      font-size: $--font-size-base;
      width: 33%;
      &:not(.first){
        margin-left: 6px;
      }
      &.a {
        width: 200px;
      }
      .button {
        border: 0px solid red;
        padding: 0px;
        max-width: 90%;
        text-align: center;
        background-color: $--color-success;
        border-radius: #{$--border-radius-base - 1};
        cursor: pointer;
        &.selected {
          background-color: $--color-warning;
          color: rgba($--color-success, 1);
        }
      }
    }
    .input-value {
      width: 50px;
      height: 12px;
      padding: 1px;
      border-radius: 0px;
      box-shadow: none;
      border: 1px solid rgba($--color-text-placeholder, 0.2);
      background-color: rgba($--color-white, 0.4);
      color: $--color-text-secondary;
    }
  }
}
.layer {
  color: $--color-text-regular;
  font-size: $--font-size-base;
  display: flex;
  border-bottom: 1px solid $--color-text-placeholder;
  &.selected {
    background-color: $--background-color-selected;
    box-shadow: inset 0px 0px 0px 1px $--color-warning;
  }
  &.margintop {
    margin-top: 50px;
  }
  &.marginbottom {
    margin-bottom: 50px;
  }
  .thumbnail {
    width: 25%;
    height: 64px;
    margin: 3px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .rows-data {
    width: 75%;
    .row {
      display: flex;
      &.first {
        padding: 11px 0px 0px 3px;
      }
      &.second {
        padding: 0px 0px 3px 0px;
        color: $--color-text-secondary;
        .buttons {
          width: 100%;
          height: 25px;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          border: 0px solid rgba($--color-text-placeholder, 0.2);
          color: $--color-text-secondary;
          .button {
            cursor: pointer;
            margin-left: 7px;
            margin-right: 4px;
          }
        }
      }
      .name {
        width: 100%;
        height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .dimensions {
        border-right: 1px solid rgba($--color-text-placeholder, 0.2);
        padding-left: 3px;
        // width: 50%;
        .label {
          color: $--color-text-secondary;
        }
        .dimensions-label {
          width: 16px;
          float: left;
          padding-top: 1px;
        }
        &.anchor {
          padding-left: 8px;
          border-right: 0px;
        }
        .input-value {
          width: 40px;
          height: 16px;
          padding: 1px;
          border-radius: 0px;
          box-shadow: none;
          border: 1px solid rgba($--color-text-placeholder, 0.2);
          background-color: rgba($--color-text-placeholder, 0.2);
          color: $--color-text-secondary;
          font-size: $--font-size-mini;
        }
      }
    }
  }
}
.pallete-header {
  color: $--color-text-secondary;
  padding: 3px 3px 3px 10px;
  text-transform: uppercase;
  font-size: $--font-size-base;
  background-color: rgba($--color-text-placeholder, 0.3);
  cursor: pointer;
}
.form-anchor-buttons {
  margin: 0 auto;
  width:156px;
  border: 0px solid green;
  .anchor-button-viewport {
    padding: 0px;
    margin: 0px;
    height: 30px;
    width: 50px;
    border: 1px solid rgba($--color-primary, 0.5);
    position: relative;
    float: left;
    // transform: scale(0.99);
    &.selected {
      border-color: $--color-warning;
    }
    .anchor-button {
      position: relative;
      border: 1px solid $--color-success;
      width: 15px;
      height: 15px;
    }
    .top-left {
      left: -1px;
      top: -1px;
    }
    .top-right {
      top: -1px;
      left: 34px;
    }
    .bottom-left {
      top: 14px;
      left: -1px;
    }
    .bottom-right {
      top: 14px;
      left: 34px;
    }
    .top-middle {
      left: 16px;
      top: -1px;
    }
    .middle-right {
      top: 7px;
      left: 34px;
    }
    .bottom-middle {
      top: 14px;
      left: 16px;
    }
    .middle-left {
      top: 7px;
      left: -1px;
    }
    .middle-middle {
      top: 7px;
      left: 16px;
    }
  }
}
.clear {
  clear: left;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/LayoutEditor/LayersPalette.vue